"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseItem = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const foundations_1 = require("../../foundations");
const useId_1 = require("../../hooks/useId");
const useWarning_1 = require("../../hooks/useWarning");
const CollapseItem = (props) => {
    const { warn } = (0, useWarning_1.useWarning)();
    const { children, title, defaultOpen } = props;
    const { toggleItem, getIsExpanded, size } = react_1.default.useContext(__1.CollapseGroupContext);
    const itemId = (0, useId_1.useId)();
    if (title === null) {
        warn("the title` prop of a CollapseItem component is null. Please pass either a string or ReactNode");
    }
    const isFirstRender = react_1.default.useRef(true);
    if (isFirstRender.current && defaultOpen) {
        toggleItem(itemId);
        isFirstRender.current = false;
    }
    const isOpen = getIsExpanded(itemId) || false;
    const contentRef = react_1.default.useRef(null);
    const targetSxProps = {
        fontWeight: "bold",
        color: "text01",
        paddingTop: 5,
        paddingBottom: 5,
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "stroke02",
        marginTop: "-1px",
        width: "100%"
    };
    switch (size) {
        case "sm":
            targetSxProps.fontSize = 2;
            targetSxProps.lineHeight = 2;
            break;
        case "md":
            targetSxProps.fontSize = 4;
            targetSxProps.lineHeight = 4;
            break;
        case "lg":
            targetSxProps.fontSize = 6;
            targetSxProps.lineHeight = 6;
            break;
    }
    if (contentRef.current) {
        if (isOpen) {
            contentRef.current.style.maxHeight =
                contentRef.current.scrollHeight + "px";
        }
        else {
            contentRef.current.style.maxHeight = "0";
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.Target, { sx: Object.assign(Object.assign({}, targetSxProps), { cursor: children ? "pointer" : "default" }), onClick: () => toggleItem(itemId), "aria-expanded": isOpen, "aria-controls": `itemContent-${itemId}` },
            react_1.default.createElement(foundations_1.Box, { sx: {
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between"
                } },
                title,
                children && (react_1.default.createElement(foundations_1.Icon, { size: "sm", icon: isOpen ? "caret-up" : "caret-down", sx: { color: "cta01", minWidth: 5, paddingLeft: 1 } })))),
        react_1.default.createElement(foundations_1.Box, { ref: contentRef, sx: {
                overflow: "hidden",
                transition: () => "max-height 300ms cubic-bezier(0.4, 0, 0, 1)",
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
                borderBottomColor: "stroke02",
                maxHeight: defaultOpen ? undefined : 0
            }, id: `itemContent-${itemId}` }, children)));
};
exports.CollapseItem = CollapseItem;
//# sourceMappingURL=CollapseItem.js.map